<template>
  <p></p>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../scss/variables';
</style>

<script>
// @flow
/*
 * Root component.
 *
 * This component corresponds to the root route (`/`) and for now just redirects to the route that we want to be the home page (`/home`).
 * If we'd set home to match (`/`) and remove this component, then the `Home` route would be active for all other sub-routes on the site (i.e. the home route would be active for `/users`). Therefore, the existence of this component.
 */
export default {
  name: 'root',
  mounted() {
    this.$router.replace({ name: 'home' })
  }
}
</script>
